<template>
  <div>
    <yjh-header></yjh-header>
    <div class="detail">
      <div class="title">{{ detail.title }}</div>
      <div class="time">{{ detail.created_at }}</div>
      <div class="img">
        <video
          v-if="detail.video_url"
          width="300"
          height="150"
          controls
          :src="detail.video_url"
          :poster="detail.cover_image"
        ></video>
        <img v-else :src="detail.cover_image" alt="" />
      </div>
      <div class="text" v-html="detail.content"></div>
    </div>
    <yjh-footer></yjh-footer>
  </div>
</template>

<script>
import footer from "@/layouts/footer";
import header from "@/layouts/header";
import axios from "axios";
export default {
  components: {
    "yjh-footer": footer,
    "yjh-header": header,
  },
  // props: ["sNav", "header"],
  data() {
    return {
      id: "",
      detail: "",
    };
  },
  created() {
    console.log(this.$route.params.id);
    this.id = this.$route.query.id;
    this.getNews(this.id);
  },
  methods: {
    getNews(id) {
      const _this = this;
      axios
        .get(process.env.VUE_APP_URL + "/api/news/detail?id=" + id)
        .then(function (res) {
          console.log(res);
          // if (res.data.code == 0) {
          //   _this.newsList = res.data.data.data;
          // }
          if (res.data.code == 0) {
            _this.detail = res.data.data;
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
  },
};
</script>

<style lang="less" scoped>
.detail {
  width: 330px;
  margin: 20px auto;
  .title {
    font-size: 20px;
    line-height: 40px;
    font-weight: 700;
  }
  .time {
    color: #da261d;
    font-weight: 700;
    font-size: 16px;
  }
  img {
    width: 300px;
    margin: 10px auto;
  }
  video {
    margin: 10px auto;
  }
  .text {
    line-height: 16px;
  }
}
</style>
